var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconSetRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-set-refresh",
    d: "M172,33.267c6.627,0,12,3.228,12,7.2,0,2.016-1.387,3.84-3.613,5.148a4.843,4.843,0,0,0,2.28-3.792c0-3.408-4.774-6.156-10.667-6.156v3.6l-5.333-4.8,5.333-4.8Zm0,16.8c-6.627,0-12-3.228-12-7.2,0-2.016,1.387-3.84,3.613-5.148a4.845,4.845,0,0,0-2.28,3.8c0,3.4,4.774,6.144,10.667,6.144v-3.6l5.333,4.8L172,53.667Z",
    transform: "translate(-160 -29.667)",
    fill: "#2fbc99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetRefresh);
export default __webpack_public_path__ + "static/media/icon-set-refresh.558fbd5ef209b27236aab8809e821a0b.svg";
export { ForwardRef as ReactComponent };